import type { GridCell } from "./types";
import { state } from "./state";
import { mazeEl } from "../dom";
import { pathUnder } from "./grid";
import { recompute, flashDenied } from "./flow";

const k = (c: GridCell) => c[0] + "," + c[1];

/**
 * Tap a floor tile to raise a wall there; tap a placed wall to remove it. Two
 * rules keep every position legal (exactly what the solver's feasible set
 * allows): you may never spend more than `budget` walls, and you may never seal
 * the treasure off — a wall that would disconnect the hero from the goal is
 * refused (the hero must always have *some* path; the puzzle is how long).
 */
export function initInteraction(): void {
  mazeEl.addEventListener("click", (e) => {
    if (state.phase !== "play") return;
    const tile = (e.target as HTMLElement).closest<SVGElement>(".t-place");
    if (!tile) return;
    const r = Number(tile.getAttribute("data-r"));
    const c = Number(tile.getAttribute("data-c"));
    const cell: GridCell = [r, c];

    if (state.hasWall(cell)) {
      state.walls = state.walls.filter((w) => k(w) !== k(cell));
      recompute();
      return;
    }

    const L = state.level();
    if (state.walls.length >= L.budget) {
      flashDenied(`Only ${L.budget} wall${L.budget === 1 ? "" : "s"} this labyrinth — remove one first.`);
      return;
    }
    // refuse a wall that would wall the treasure off entirely
    if (!pathUnder(L, [...state.walls, cell])) {
      flashDenied("That would seal the treasure off — the hero must always have a way through.");
      return;
    }
    state.walls = [...state.walls, cell];
    recompute();
  });
}
